import { Injectable } from '@angular/core';
import { EVENT_CLICK_TYPE } from '../../../../constants/utils';
import { AnalyticsParams, ClickEventAnalytics } from '../../../../models/utils';
import { AnalyticsBaseDetailsClick } from '../../../../models/utils/analytics-extended.interfaces';
import { AnalyticsDataPopulateHelperSupportService } from './analytics-data-populate-helper-support.service';
@Injectable({
  providedIn: 'root'
})
export class AnalyticsDataPopulateSuperHelperService extends AnalyticsDataPopulateHelperSupportService {
  createButtonAnalytics(
    params: AnalyticsParams,
    pageAttribute?: string,
    componentType?: string,
    componentName?: string
  ): ClickEventAnalytics {
    const linkWithoutAction = params.action ? false : true;
    const details = this.getAnalyticsDetails(
      params.elementRef,
      params.action,
      true,
      params.pageSection,
      pageAttribute,
      componentType
    );
    const baseAnalytics = {
      details: details,
      type: EVENT_CLICK_TYPE.BUTTON,
      eventType: params.eventType,
      includeProfile: true, // Changed from false to true to include user profile
      elementRef: params.elementRef,
      linkWithoutAction,
      pageAttribute,
      componentType,
      componentName
    };
    return this.handleBaseAnalytics(baseAnalytics);
  }

  getDefaultLinkDetails(
    elementRef: HTMLElement,
    action: string,
    pageSection: string,
    useDataAttributes?: boolean
  ): AnalyticsBaseDetailsClick {
    const label = this.getLinkName(elementRef, useDataAttributes);
    const eventDetail = this.getLinkEventDetail(
      action,
      label,
      useDataAttributes
    ).replace(': ', ':');
    return {
      label,
      eventDetail,
      pageSection,
      action
    };
  }

  getAnalyticsDetails(
    elementRef: HTMLElement,
    action: string,
    isButton: boolean,
    pageSection: string,
    pageAttribute?: string,
    componentType?: string,
    useDataAttributes?: boolean
  ): AnalyticsBaseDetailsClick {
    if (pageAttribute && componentType) {
      return this.getComponentBasedDetails(
        elementRef,
        componentType,
        pageAttribute
      );
    }
    return this.getDefaultDetails(
      elementRef,
      isButton,
      pageSection,
      action,
      useDataAttributes
    );
  }

  getDefaultDetails(
    elementRef: HTMLElement,
    isButton: boolean,
    pageSection: string,
    action?: string,
    useDataAttributes?: boolean
  ): AnalyticsBaseDetailsClick {
    if (!action) {
      return this.getComponentBasedDetails(elementRef, pageSection);
    } else {
      return isButton
        ? this.getDefaultButtonDetails(elementRef, action, pageSection)
        : this.getDefaultLinkDetails(
            elementRef,
            action,
            pageSection,
            useDataAttributes
          );
    }
  }

  createLinkAnalytics(
    params: AnalyticsParams,
    pageAttribute?: string,
    componentType?: string,
    componentName?: string,
    useDataAttributes?: boolean
  ): ClickEventAnalytics {
    const linkWithoutAction = params.action ? false : true;
    const details = this.getAnalyticsDetails(
      params.elementRef,
      params.action,
      false,
      params.pageSection,
      pageAttribute,
      componentType,
      useDataAttributes
    );
    const baseAnalytics = {
      details: details,
      type: EVENT_CLICK_TYPE.LINK,
      eventType: params.eventType,
      includeProfile: true,
      elementRef: params.elementRef,
      linkWithoutAction,
      pageAttribute,
      componentType,
      componentName
    };
    return this.handleBaseAnalytics(baseAnalytics);
  }
}
